import { type AttributeConfig, AttributeConfigContext } from "@src/context/attributeConfig/AttributeConfigContext";
import * as React from "react";

export const useAttributeConfig = (): AttributeConfig => {
    return React.useContext(AttributeConfigContext);
};
